import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import TakeayaRealEstate from './TakeayaComponents';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import PropertiesPage from './pages/PropertiesPage';
import Footer from './components/Footer';
import FloatingContactButton from './components/FloatingContactButton';
import { Helmet } from 'react-helmet';
import { useMeta } from './context/MetaContext'; // adjust path accordingly

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const GlobalHelmet = () => {
  const meta = useMeta();

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      {meta.image_url && <meta property="og:image" content={meta.image_url} />}
    </Helmet>
  );
};

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <GlobalHelmet />
        <div className="flex flex-col min-h-screen">
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<TakeayaRealEstate />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/properties" element={<PropertiesPage />} />
            </Routes>
          </main>
          <Footer />
          <FloatingContactButton />
        </div>
      </Router>
    </div>
  );
}

export default App;